// ======================================================================
// File Name       : ServiceNoticeUserListDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table } from 'react-bootstrap';
import TableHead from '../../TableHead';
import RenderField from '../../../utils/ReduxFormUtils';
import { DORMANT_STATE } from '../../../constants';

const thead = [
  { title: '', sortBy: null, width: 50 },
  { title: 'ログインID', sortBy: null },
  { title: 'ユーザー名', sortBy: null },
];

class ServiceNoticeUserListDialog extends React.Component {
  render() {
    const { userList, edittingUsers } = this.props;
    let tbody = null;
    if (userList && userList.length) {
      tbody = userList.map((user, index) => {
        const disabled =
          edittingUsers &&
          edittingUsers.bySecernIds &&
          edittingUsers.bySecernIds[user.userSecernId];
        return (
          <tr key={index} className={user.dormantState == DORMANT_STATE.INACTIVE ? 'inactive-class' : ''}>
            <td className="text-center" style={{ paddingTop: '0px', paddingBottom: '0px' }}>
              <RenderField
                name={`edittingUserList.${user.userSecernId}`}
                value={1}
                type="checkbox"
                disabled={disabled}
              />
            </td>
            <td className="text-left">{user.loginId}</td>
            <td className="text-left">{user.userName}</td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Table striped hover>
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
      </div>
    );
  }
}

export default ServiceNoticeUserListDialog;
